import { render } from "./AsahiLogoNew.vue?vue&type=template&id=7ccdccf2&scoped=true"
import script from "./AsahiLogoNew.vue?vue&type=script&lang=js"
export * from "./AsahiLogoNew.vue?vue&type=script&lang=js"

import "./AsahiLogoNew.vue?vue&type=style&index=0&id=7ccdccf2&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ccdccf2"]])

export default __exports__